import { render, staticRenderFns } from "./HomeCollectionsTable.vue?vue&type=template&id=746ec7f0&scoped=true&"
import script from "./HomeCollectionsTable.vue?vue&type=script&lang=js&"
export * from "./HomeCollectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./HomeCollectionsTable.vue?vue&type=style&index=0&id=746ec7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746ec7f0",
  null
  
)

export default component.exports